import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ModalHeader, ModalBody, Button } from 'reactstrap';

// import makeUrl from "../../../lib/makeUrl";
import { openLoginModal } from '../../../redux/actions/authActions';
import { closeOverviewModal } from '../../../redux/actions/trekOverviewActions';

import UseAsTemplateButton from '../DayOverview/UseAsTemplateButton';

const EditNotifications = props => {
  const renderMessage = {
    UseTemplate: (
      <div>
        <p>This is a template. You need to use this template in order to edit.</p>
        <UseAsTemplateButton />
      </div>
    ),
    RequestToJoin: (
      <p>You can only edit your own treks. So make your own or follow this trek.</p>
    ),
    LoginToJoin: (
      <div>
        <p>
          Did you create this trek ? <br />
          If so just login and try editing again.
          <br />
          If this is not your trek you can login to join this trek or create your own.
        </p>
        <Button
          color="primary"
          onClick={() => {
            props.closeOverviewModal();
            props.openLoginModal();
          }}
        >
          Login
        </Button>
      </div>
    ),
    LoginToUseTemplate: (
      <div>
        <p>
          Looks like you are not Logged In. Once you login you can use this trek template
          and create a personalize trek for yourself.
        </p>
        <Button
          color="yellow"
          onClick={() => {
            props.closeOverviewModal();
            props.openLoginModal();
          }}
        >
          Login
        </Button>
      </div>
    ),
    OnlyOwnerCanEdit: (
      <div>
        <p>Looks like you did not create this trek. Only owners can edit their trek.</p>
      </div>
    ),
    NeedToBeAGuide: (
      <div>
        <p>
          You should be a Guide in our system to create a Guided trek. In order to be a
          guide, you need to fill the form.
        </p>
        <a
          href="https://goo.gl/forms/pNhLx43rNfThOr0h1"
          rel="nofollow noopener noreferrer"
          target="_blank"
        >
          <Button color="yellow">Take me to the form.</Button>
        </a>
      </div>
    ),
  };

  const message = props.type && renderMessage[props.type];

  return (
    <div>
      <ModalHeader toggle={() => props.closeOverviewModal()} />
      <ModalBody>
        <div className="text-center">{message}</div>
      </ModalBody>
    </div>
  );
};

export default withRouter(
  connect(
    null,
    { openLoginModal, closeOverviewModal }
  )(EditNotifications)
);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/UiNotifications/UiNotifications.jsx